import React from 'react';
import { Link, Route } from 'react-router-dom';
import Logo from '@vromo/icons/logo';
import { css } from 'emotion';

export default function LogoButton() {
    return (
        <Link to="/" style={{ flexShrink: 0 }}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                }}>
                <Logo style={{ height: 28, margin: 5 }} />
            </div>
        </Link>
    );
}
